var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_774_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3599 34C49.3599 42.4831 42.483 49.36 33.9999 49.36C25.5168 49.36 18.6399 42.4831 18.6399 34C18.6399 25.5169 25.5168 18.64 33.9999 18.64C42.483 18.64 49.3599 25.5169 49.3599 34Z",
    fill: "url(#paint0_radial_774_6270)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 19.28C25.8704 19.28 19.28 25.8704 19.28 34C19.28 42.1296 25.8704 48.72 34 48.72C42.1296 48.72 48.72 42.1296 48.72 34C48.72 25.8704 42.1296 19.28 34 19.28ZM18 34C18 25.1634 25.1634 18 34 18C42.8366 18 50 25.1634 50 34C50 42.8366 42.8366 50 34 50C25.1634 50 18 42.8366 18 34Z",
    fill: "#BDBDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 41.6332L41 39.9681C41 39.0849 40.6576 38.2379 40.0481 37.6134C39.4386 36.9889 38.612 36.638 37.75 36.638L31.25 36.638C30.388 36.638 29.5614 36.9889 28.9519 37.6134C28.3424 38.2379 28 39.0849 28 39.9681L28 41.6332M37.75 29.9779C37.75 31.8171 36.2949 33.308 34.5 33.308C32.705 33.308 31.25 31.8171 31.25 29.9779C31.25 28.1388 32.705 26.6478 34.5 26.6478C36.2949 26.6478 37.75 28.1388 37.75 29.9779Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_774_6270",
    x: 0.639893,
    y: 0.640015,
    width: 66.72,
    height: 66.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_774_6270"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_774_6270",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9999 34) rotate(90) scale(15.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6429CD",
    stopOpacity: 0.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActiveIcon);
export default __webpack_public_path__ + "static/media/profileActiveIcon.09bdbbdc5f53e179b2267e0d966b7e16.svg";
export { ForwardRef as ReactComponent };